const convertWearerSideToFull = (rawName) => {
    if (!rawName.startsWith('WL ') && !rawName.startsWith('WR ')) {
        return rawName;
    }
    const isLeft = rawName.startsWith('WL ');
    const isRight = rawName.startsWith('WR ');
    const restOfName = rawName.slice(3); // Remove 'WL ' or 'WR '
    return `Wearer's ${isLeft ? 'Left' : isRight ? 'Right' : ''} ${restOfName}`;
};
export const convertRegionName = (name) => {
    return convertWearerSideToFull(name);
};
